import { GroupDivision } from "../../../shared/enums/GroupDivision";
import { StatusApproval } from "../../../shared/enums/StatusApproval";
import { ContractType } from "../../../shared/enums/ContractType";
import { StatusInvoice } from "../../enums/StatusInvoice";

export class ApprovalsSearchFactory {
    divisions: GroupDivision[] = [];
    projects: string[] = [];
    years: string[] = [];
    months: string[] = [];
    companies: string[] = [];
    consultants: string[] = [];
    responsibles: string[] = [];
    statusApprovals: StatusApproval[] = [];
    statusInvoices: StatusInvoice[] = [];
    contracts: ContractType[] = [];
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    byProject:boolean = false;
    industries: string[] = [];
    excellenceCenters: string[] = [];
    supportCenters: string[] = [];
    subDivisions: string[] = [];


    newSearch(){
        let month = new Date().getMonth() - 1;
        let year = new Date().getFullYear();

        if (month == 11)
            year = year - 1;

        let search = {
            year:year,
            month:month,
            years:this.years,
            months:this.months,
            divisions:this.divisions,
            projects:this.projects,
            companies:this.companies,
            consultants:this.consultants,
            statusApprovals:this.statusApprovals,
            statusInvoices:this.statusInvoices,
            contracts:this.contracts,
            skip:this.skip,
            limit:this.limit,
            totalItems:this.totalItems,
            byProject:this.byProject,
            industries:this.industries,
            excellenceCenters:this.excellenceCenters,
            supportCenters:this.supportCenters,
            subDivisions:this.subDivisions,
        };

        return search;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/factories/approvals/ApprovalsSearch.factory.ts